<template>
  <div class="d-flex align-items-baseline radios" :class="getClass()">
    <template v-for="choice in choices">
      <radio
        v-if="choice.available !== false || choice.value === value"
        :id="`${name}-${choice.value}`"
        :key="choice.value"
        :label="choice.text"
        :value="choice.value"
        :checked="choice.value === value"
        :required="required"
        :options="getOptions(choice)"
        :name="name"
        :class="getItemClass()"
        :disabled="disabled || choice.available === false"
        @update:data="(data) => $emit('update:data', data)"
      >
      </radio>
    </template>
  </div>
</template>

<script>
import Radio from '@kanrisha/components/Elements/Form/Radio';

export default {
  components: {
    Radio,
  },
  props: {
    name: { type: String, default: '' },
    value: { type: String, default: '' },
    attribute: { type: String, default: '' },
    choices: { type: Object, default: () => {} },
    options: { type: Object, default: () => {} },
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  emits: ['update:data'],
  setup(props) {
    const getClass = () => {
      let cssClasses = '';

      if (props.options?.border === 'none') {
        cssClasses += 'border-0';
      }

      return cssClasses;
    };

    const getItemClass = () => {
      let cssClasses = props.options?.direction === 'vertical' ? 'col-12' : 'col-12 col-md';

      if (Object.keys(props.choices).length < 4 && props.options?.direction !== 'vertical') {
        cssClasses += '-3';
      }

      return cssClasses;
    };

    const getOptions = (choice) => {
      if (!props.options?.imagePath) {
        return null;
      }

      return { image: props.options.imagePath + '/' + props.name + '-' + choice.value + '.png' };
    };

    return {
      getClass,
      getItemClass,
      getOptions,
    };
  },
};
</script>
